export default __webpack_public_path__ + "static/media/ic-personal-lessons.b2a93392.svg";